<template>
  <fragment>
    <div class="confectionModal">
      <div class="confectionModal-top">
        <img
          class="confectionModal-image img-responsive"
          alt="envelope example"
          :src="image"
          width="350px"
        >
      </div>

      <div class="confectionModal-content">
        <h2 class="confectionModal-title">Włożenie kuponów do kopert ozdobnych</h2>
        <section class="confectionModal-descriptions">
          <p>
            Cenimy Twój czas, dlatego umieścimy kartę w kopercie za Ciebie.
          </p>
        </section>
      </div>
    </div>
  </fragment>
</template>

<script>
export default {
  name: 'EnvelopeCouponPutInModal',
  props: {
    image: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>

</style>
